(function () {
  function easterSunday(y) {
    const a = y % 19;
    const b = Math.floor(y / 100);
    const c = y % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }

  function dateKey(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function addDays(d, n) {
    const r = new Date(d);
    r.setDate(d.getDate() + n);
    return r;
  }

  function danishHolidays(year) {
    const easter = easterSunday(year);
    return [
      new Date(year, 0, 1),
      addDays(easter, -3),
      addDays(easter, -2),
      addDays(easter, 1),
      addDays(easter, 39),
      addDays(easter, 50),
      new Date(year, 11, 25),
      new Date(year, 11, 26)
    ].map(dateKey);
  }

  function dutchHolidays(year) {
    const easter = easterSunday(year);
    const kingsDay = new Date(year, 3, 27);
    if (kingsDay.getDay() === 0) kingsDay.setDate(26);
    const days = [
      new Date(year, 0, 1),
      addDays(easter, 1),
      kingsDay,
      addDays(easter, 39),
      addDays(easter, 50),
      new Date(year, 11, 25),
      new Date(year, 11, 26)
    ];
    if (year % 5 === 0) days.push(new Date(year, 4, 5));
    return days.map(dateKey);
  }

  function toLocale(lang) {
    const map = { da: 'da-DK', nl: 'nl-NL', de: 'de-DE', sv: 'sv-SE', nb: 'nb-NO', no: 'nb-NO', en: 'en-US' };
    return map[String(lang || '').toLowerCase()] || 'en-US';
  }

  function copenhagenNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    const get = (t) => Number(parts.find((p) => p.type === t).value);
    return { date: new Date(get('year'), get('month') - 1, get('day')), minutes: get('hour') * 60 + get('minute') };
  }

  function isBusinessDay(date, holidays) {
    const day = date.getDay();
    return day !== 0 && day !== 6 && !holidays.has(dateKey(date));
  }

  function addBusinessDays(date, n, holidays) {
    const r = new Date(date);
    let count = 0;
    while (count < n) {
      r.setDate(r.getDate() + 1);
      if (isBusinessDay(r, holidays)) count++;
    }
    return r;
  }

  function calculateNL(cutoffTime) {
    const now = copenhagenNow();
    const y = now.date.getFullYear();
    const dk = new Set([...danishHolidays(y), ...danishHolidays(y + 1)]);
    const nl = new Set([...dutchHolidays(y), ...dutchHolidays(y + 1)]);
    const [h, m] = String(cutoffTime || '14:00').split(':').map(Number);
    let ship = new Date(now.date);
    if (!isBusinessDay(ship, dk) || now.minutes >= h * 60 + (m || 0)) {
      ship = addBusinessDays(ship, 1, dk);
    }
    return { fromDate: addBusinessDays(ship, 2, nl), toDate: addBusinessDays(ship, 4, nl) };
  }

  function calculateWindow(locale, country, cutoffTime) {
    if (String(country || '').toUpperCase() === 'NL') return calculateNL(cutoffTime);
    const today = new Date();
    const isDK = country ? String(country).toUpperCase() === 'DK' : locale === 'da-DK';
    const isNL = String(country || '').toUpperCase() === 'NL';
    const baseOffset = isDK ? 1 : 2;
    const windowDays = isDK ? 1 : 2;

    const y = today.getFullYear();
    const holidayList = [...danishHolidays(y), ...danishHolidays(y + 1)];
    if (isNL) holidayList.push(...dutchHolidays(y), ...dutchHolidays(y + 1));
    const holidays = new Set(holidayList);

    function skipNonDelivery(date) {
      while (true) {
        const day = date.getDay();
        if (day === 0) { date.setDate(date.getDate() + 1); continue; }
        if (day === 6) { date.setDate(date.getDate() + 2); continue; }
        if (holidays.has(dateKey(date))) { date.setDate(date.getDate() + 1); continue; }
        break;
      }
      return date;
    }

    const isFridayShipping = isDK && today.getDay() === 5 && !holidays.has(dateKey(today));

    let fromDate, toDate;
    if (isFridayShipping) {
      fromDate = addDays(today, 1);
      toDate = addDays(today, 4);
      if (holidays.has(dateKey(fromDate))) skipNonDelivery(fromDate);
      skipNonDelivery(toDate);
    } else {
      fromDate = new Date(today);
      fromDate.setDate(today.getDate() + baseOffset);
      skipNonDelivery(fromDate);
      toDate = new Date(fromDate);
      toDate.setDate(fromDate.getDate() + windowDays);
      skipNonDelivery(toDate);
    }

    return { fromDate, toDate };
  }

  function format(date, locale) {
    const s = window.JNStrings || {};
    const months = String(s.monthsShort || '').split(',');
    if (locale !== 'en-US' && months.length === 12 && s.dateFormatShort) {
      return s.dateFormatShort.replace('[day]', date.getDate()).replace('[month]', months[date.getMonth()].trim());
    }
    const options = locale === 'da-DK'
      ? { day: 'numeric', month: 'short' }
      : locale === 'nl-NL'
        ? { day: 'numeric', month: 'long' }
        : { month: 'long', day: 'numeric' };

    let formatted = new Intl.DateTimeFormat(locale, options).format(date);

    if (locale === 'en-US') {
      const day = date.getDate();
      let suffix = 'th';
      if (day % 10 === 1 && day !== 11) suffix = 'st';
      else if (day % 10 === 2 && day !== 12) suffix = 'nd';
      else if (day % 10 === 3 && day !== 13) suffix = 'rd';
      formatted = formatted.replace(/\d+/, `${day}${suffix}`);
    }

    return formatted;
  }

  function formatRange(from, to, locale, tpl) {
    return (tpl || '[from] - [to]').replace('[from]', format(from, locale)).replace('[to]', format(to, locale));
  }

  function etaText(etaStr, windowDays, locale, tr) {
    const from = new Date(etaStr);
    const to = new Date(from);
    to.setDate(from.getDate() + windowDays);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (from >= today) return formatRange(from, to, locale, tr.range);
    if (to >= today) return (tr.latest || '[to]').replace('[to]', format(to, locale));
    return null;
  }

  function resolve(variant, config) {
    const locale = toLocale(config.locale);
    const tr = config.translations || {};
    const low = config.lowStockSettings || {};
    const windowDays = config.deliveryWindowDays || 7;
    const qty = Number(variant.inventoryQuantity) || 0;
    const policy = variant.inventoryPolicy || 'deny';
    const isBundlePreorder = String(variant.bundlePreorder) === 'true';

    function fmtRange(from, to) {
      return formatRange(from, to, locale, tr.range);
    }
    function etaRange(etaStr) {
      return etaText(etaStr, windowDays, locale, tr) || tr.expectedUnknown;
    }

    let status, deliveryText, kind;

    if (isBundlePreorder && variant.eta) {
      status = tr.preorder; deliveryText = etaRange(variant.eta); kind = 'preorder';
    } else if (isBundlePreorder) {
      status = tr.preorder; deliveryText = tr.expectedUnknown; kind = 'preorder';
    } else if (qty > 0) {
      const isLow = low.enabled && qty <= low.threshold;
      status = isLow ? low.message : tr.instock;
      const w = calculateWindow(locale, config.country, config.countdown && config.countdown.cutoffTime);
      deliveryText = fmtRange(w.fromDate, w.toDate);
      kind = 'instock';
    } else if (policy === 'continue') {
      status = tr.preorder;
      if (variant.eta) { deliveryText = etaRange(variant.eta); kind = 'preorder'; }
      else { deliveryText = tr.expectedUnknown; kind = 'preorder'; }
    } else {
      status = tr.outofstock; deliveryText = tr.expectedUnknown; kind = 'outofstock';
    }

    return { status: status, deliveryText: deliveryText, kind: kind };
  }

  window.JNDelivery = { calculateWindow: calculateWindow, format: format, formatRange: formatRange, etaText: etaText, resolve: resolve, toLocale: toLocale };
})();
